<div class="login-container flex justify-center items-center">
    <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <h1 class="login-title">Login</h1>

        <div class="form-group">
            <label for="username">User Name</label>
            <div class="password-input">
                <img class="lock-icon" src="assets/images/user-icon.svg" />
                <input id="username" type="text" formControlName="userName" autocomplete="off" class="username" />
            </div>
        </div>

        <div class="form-group">
            <label for="password">Password</label>
            <div class="password-input">
                <img class="lock-icon" src="assets/images/lock-icon.svg" />
                <input id="password" type="password" formControlName="password" class="password" />
            </div>
        </div>

        <button type="submit" class="login-button" [disabled]="loginForm.invalid">Login</button>
    </form>
</div>
<p-toast></p-toast>
